import React, { useEffect, useState, useContext } from 'react';
import { Spinner } from '../../StyledComponent';
import DropDownDisabled from '../../Reutilizaveis/DropDownDisabled';
import { ContextoFinanceiro } from '../../../services/financeiro';
import ContractSelector from '../../ContractSelector';
const Contratos = ({ setContrato, idVenda, tema }) => {
  // lista de nomes dos contratos
  const [contratosCliente, setContratosCliente] = useState([]);

  // lista de nomes dos contratos
  // const [dadosContratosCliente, setDadosContratosCliente] = useState([]);

  const [loading, setLoading] = useState(true);

  // contrato selecionado pelo cliente
  const [contratoSelecionado, setContratoSelecionado] = useState({});

  const [error, setError] = useState(false);

  // contexto
  const { getContratosCliente } = useContext(ContextoFinanceiro);

  const [contratosClientRaw, setContratosClienteRaw] = useState([]);

  useEffect(() => {
    getContratos();
  }, []);

  useEffect(() => {
    if (contratosCliente.length > 0) {
      // verificação quando o cliente clica na notificação
      if (idVenda != null) {
        let idVendaAtual = idVenda;

        let contratoRedirecionado = [];
        contratoRedirecionado = contratosCliente.filter((contrato) => {
          return contrato?.idVenda == idVendaAtual;
        });

        if (contratoRedirecionado.length == 0) {
          let temp;
          temp = contratosClientRaw.filter((contrato) => {
            return contrato.idVendaCarteira == idVendaAtual;
          });
          contratoRedirecionado = contratosCliente.filter((contrato) => {
            return contrato?.idVenda == temp[0]?.idVenda;
          });

          setContratoSelecionado(contratoRedirecionado[0]);
        } else setContratoSelecionado(contratoRedirecionado[0]);
      } else {
        setContratoSelecionado(contratosCliente[0]);
      }
    }
  }, [contratosCliente, idVenda]);

  useEffect(() => {
    setContrato(contratoSelecionado);
  }, [contratoSelecionado]);

  async function getContratos() {
    let resultGetContratosCliente = [];

    try {
      resultGetContratosCliente = await getContratosCliente();

      setContratosClienteRaw(resultGetContratosCliente.data);

      let contratosSemProSoluto = [];

      // remove contrato pro soluto
      for (let item of resultGetContratosCliente.data) {
        if (
          resultGetContratosCliente.data.findIndex(
            (cont) => cont?.idVendaCarteira == item?.idVenda
          ) < 0
        ) {
          contratosSemProSoluto.push(item);
        }
      }

      // setDadosContratosCliente(contratosSemProSoluto);

      trataNomeContrato(contratosSemProSoluto);

      setLoading(false);
    } catch (error) {
      setLoading(false);

      setError(true);
    }
  }

  function trataNomeContrato(resultGetContratosCliente) {
    let tempContratosCliente = [];

    resultGetContratosCliente.forEach((contrato) => {
      // para remover os pro solutos

      if (
        resultGetContratosCliente.findIndex(
          (cont) =>
            cont.idVendaCarteira == contrato.idVenda &&
            cont.idVendaCarteira != null
        ) < 0
      ) {
        tempContratosCliente.push({
          descricao: contrato.descricaoProduto,
          identificador: contrato.identificador,
          codOcorrencia: contrato.codOcorrencia,
          elegivelRenegociacao: contrato.elegivelRenegociacao,
          contrato,
        });
      }
    });

    setContratosCliente(
      contratosParaFiltro(tempContratosCliente),
      setLoading(false)
    );
  }

  function contratosParaFiltro(tempContratosCliente) {
    let tempContratos = [];

    tempContratosCliente.forEach((contrato) => {
      if (
        contrato?.contrato?.descricaoProduto
          ?.toLocaleLowerCase()
          .includes('taxas')
      ) {
        tempContratos.push({
          nome:
            contrato?.contrato.statusVendaPortal == '3'
              ? 'Quitado - ' +
                contrato?.contrato.nomeEmpreendimento +
                ' - ' +
                contrato?.contrato.identificador
              : contrato?.contrato.nomeEmpreendimento +
                ' - ' +
                contrato?.contrato.identificador,
          paraFiltroDescricaoProduto: {
            descricao: contrato?.contrato.descricao,
            numContrato: contrato?.contrato.idContratoCliente,
          },
          contrato: contrato?.contrato.contrato,
          codOcorrencia: contrato?.contrato.codOcorrencia,
          idVenda: contrato?.contrato.idVenda,
          idContratoCliente: contrato.contrato.idContratoCliente,
          ...contrato,
        });
      } else {
        tempContratos.push({
          nome:
            contrato?.contrato.statusVendaPortal == '3'
              ? 'Quitado - ' +
                contrato?.contrato.descricaoProduto +
                ' - ' +
                contrato?.contrato.identificador
              : contrato?.contrato.descricaoProduto +
                ' - ' +
                contrato?.contrato.identificador,
          paraFiltroDescricaoProduto: {
            descricao: contrato?.contrato.descricao,
            numContrato: contrato?.contrato.idContratoCliente,
          },
          contrato: contrato?.contrato.contrato,
          codOcorrencia: contrato?.contrato.codOcorrencia,
          idVenda: contrato?.contrato.idVenda,
          idContratoCliente: contrato.contrato.idContratoCliente,
          ...contrato,
        });
      }
    });

    const orderType = (typeA, typeB) => (typeA.nome > typeB.nome ? 1 : -1);

    return tempContratos.sort(orderType);
  }

  if (loading) return <Spinner />;

  if (error) return <p>Ocorreu um erro, tente novamente mais tarde</p>;

  localStorage.setItem('contratosCliente', JSON.stringify(contratosCliente));

  return (
    <>
      {contratosCliente.length == 0 && (
        <DropDownDisabled
          obrigatorio={true}
          largura={'100%'}
          nomeDropDown={'Contrato'}
          margin={'25px 25px 25px 0'}
        >
          Nenhum contato encontrado.
        </DropDownDisabled>
      )}
      {contratosCliente.length == 1 && (
        <DropDownDisabled
          obrigatorio={true}
          largura={'100%'}
          nomeDropDown={'Contrato'}
          margin={'25px 25px 25px 0'}
        >
          {contratosCliente[0].nome}
        </DropDownDisabled>
      )}
      {contratosCliente.length > 1 && (
        <>
          <ContractSelector
            contratosCliente={contratosCliente}
            contratoSelecionado={contratoSelecionado}
            setContratoSelecionado={setContratoSelecionado}
            tema={tema}
          />
        </>
      )}
    </>
  );
};

export default Contratos;
